export default __webpack_public_path__ + "static/media/ic-video-black.bd67bd9e.svg";